<template>
    <div class="row my-3 mx-0">
        <div class="col-12">
            <button type="button" v-on:click="createRemoteJob()" class="btn btn-primary float-right mx-1">{{ this.button_text }}</button>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "create-remote-job-button",
    props: {
        button_text: String,
        put_data_in_session_route: String,
        create_remote_job_route: String,
        task: Object,
    },
    data() {
        return {
            sessionValue: 'task_for_remote',
            taskForRemote: this.task,
        }
    },
    methods: {
        createRemoteJob() {
            let self = this;
            axios.post(self.put_data_in_session_route, {'dataType': self.sessionValue, 'data': self.taskForRemote})
                .then(function (response) {
                    window.location.href = self.create_remote_job_route;
                }).catch(function (error) {
                console.log(error);
            });
        },
    }
}
</script>

<style scoped>

</style>
